export const troubleshootConstants = {
    TROUBLESHOOT_ACTION_TYPES: {
        GET_TROUBLESHOOTS_REQUEST: 'GET_TROUBLESHOOTS_REQUEST',
        GET_TROUBLESHOOTS_SUCCESS: 'GET_TROUBLESHOOTS_SUCCESS',
        GET_TROUBLESHOOTS_FAILURE: 'GET_TROUBLESHOOTS_FAILURE',
    },
};
